import {runElectronFunc} from "./comm";

// props: {url, projectSrno, postSrno, remarkSrno, x, y, isInit}
const open = (props) => {
    if(window.ElectronProjectApi) runElectronFunc('ElectronProjectApi', 'open', props);
    else fn_openProjectForElectron(props.url, props.projectSrno, props.postSrno, props.remarkSrno, props.x, props.y, props.isInit)
}

const openJoinPage = (props) => {
    if(window.ElectronProjectApi) runElectronFunc('ElectronProjectApi', 'openJoinPage', props);
}

const change = (props) => {
    const {projectSrno, postSrno, remarkSrno} = props;
    if (projectSrno) ViewChanger.loadPageJson({
        code: 'detail',
        first: projectSrno,
    });
    if (postSrno) {
        PostPopup.togglePostView(projectSrno, postSrno, remarkSrno, null, true);
    }
}

export {
    open,
    openJoinPage,
    change,
};